// extracted by mini-css-extract-plugin
module.exports = {"StockOptionsRow":"StockOptionsRow_StockOptionsRow__ou1FQ","strike":"StockOptionsRow_strike__BuZB8"};